import { usePostHog } from 'posthog-js/react';
import { MouseEvent, useState } from 'react';
import { trackAndNavigate } from '../../../Config/libs/analytics';
import { PostHogFeatureFlagEnum } from '../../enum/PostHogEvent.enum';
import { OAUTH_NEXT_STORAGE_KEY, readNextParamFromSearch } from '../../utils/safeNextPath';
import { withSignupAttribution } from '../../utils/signupAttribution';
import { OAUTH_TRACKING_KEY } from './useSocialRegister.hook';

export const useSocialLogin = () => {
  const postHog = usePostHog();
  const [isNavigating, setIsNavigating] = useState(false);

  const handleSocialLogin = (
    event: MouseEvent<HTMLButtonElement>,
    provider: string,
    link: string,
  ): void => {
    event.preventDefault();
    if (isNavigating) return;
    setIsNavigating(true);

    // Store variant in localStorage before OAuth redirect for tracking after success
    const backgroundVariant = postHog.getFeatureFlag(PostHogFeatureFlagEnum.SignupBackgroundTest);
    localStorage.setItem(
      OAUTH_TRACKING_KEY,
      JSON.stringify({
        variant: backgroundVariant,
        provider: provider.toLowerCase(),
        timestamp: Date.now(),
      }),
    );

    // Preserve any post-login redirect (e.g. MCP OAuth authorize) across the provider round-trip.
    const nextPath = readNextParamFromSearch(window.location.search);
    if (nextPath) {
      sessionStorage.setItem(OAUTH_NEXT_STORAGE_KEY, nextPath);
    } else {
      sessionStorage.removeItem(OAUTH_NEXT_STORAGE_KEY);
    }

    trackAndNavigate(
      `login_${provider}_click`,
      { event_category: 'User login', event_label: 'login_form' },
      // "Sign in with Google" creates the account when the email is unknown, so this is a signup entry point too and must carry attribution.
      () => {
        window.location.href = withSignupAttribution(link);
      },
    );
  };

  return {
    handleSocialLogin,
    isNavigating,
  };
};
